// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d6234f1c","703":"0100d304"}[chunkId] + ".chunk.js";
};